import { CSSProperties } from 'react'

const styles = {
  headerText: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center'
  } as CSSProperties,
  subHeaderText: {
    fontSize: 16,
  } as CSSProperties,
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
  } as CSSProperties,
  cancelButton: {
    backgroundColor: 'gray',
    color: 'white',
    fontWeight: 'bold',
    width: 90,
    borderRadius: 10
  } as CSSProperties,
  trashButton: {
    backgroundColor: 'red',
    color: 'white',
    fontWeight: 'bold',
    width: 90,
    borderRadius: 10
  } as CSSProperties,
}

export default styles
